import {Breadcrumbs, ErrorPopup, Notice, Title} from '@management-ui/core';
import {reverse} from 'named-urls';
import React from 'react';
import routes from '../../../../routes';

const Wrapper = ({title, material, loading, crumbs, errors, children}) => {
  return (
    <>
      <Breadcrumbs crumbs={crumbs}/>
      <Title title={title} loading={loading}/>
      <Notice
        display={material && material.archived}
        message={[
          'This material has been archived and is therefore no longer available.',
          material?.deleted_at ? 'You won\'t be able to modify it unless it is restored.' : 'A relation was archived therefore you can not restore it directly'
        ].join(' ')}
      />
      {children}
      <ErrorPopup errors={['material']} messages={errors}/>
    </>
  );
}

Wrapper.standardCrumbs = [
  {title: 'Materials', link: routes.materials.index}
];
Wrapper.archiveCrumbs = [
  {title: 'Archive', link: routes.archive.index},
  {title: 'Materials', link: reverse(routes.archive.index, {tab: 'materials'})}
];

export default Wrapper;
